<template>
    <sg-wire 
    :can-skip="newUser"
    @wire="onWire" 
    @skip="onSkip" 
    />
</template>

<script>
    import SgWire from '@/components/SgWire'
    import pageMixin from './pageMixin'

    export default {
        props: {
            newUser: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        components: {
            SgWire
        },

        mixins: [pageMixin],

        methods: {

            onWire(abonents) {
                this.$api.wireServices(abonents)
                    .then(query => {
                        if (this.newUser) {
                            this.regOk(query)
                        } else {
                            this.wiredOk(query)
                        }
                    })
                    .catch(error => {
                        this.$eventBus.$emit('error', error)
                    })
            },

            onSkip() {
                this.$api.skipWire()
                    .then(query => {
                        this.regOk(query)
                    })
                    .catch(error => {
                        this.$eventBus.$emit('error', error)
                    })
            },

            askWire() {

                this.$eventBus.$emit('modal:dialog', {
                    props: {
                        message: 'К Вашей учетной записи не привязан номер телефона. Для того, чтобы привязать услуги, необходимо указать номер телефона.',
                        acceptText: 'Привязать',
                        rejectText: 'Отмена'
                    },
                    dialogProps: {
                        noClickAnimation: true,
                        persistent: true,
                    },
                    listeners: {
                        reject: () => {
                            this.rejectWire()
                        },
                        accept: () => {
                            this.wirePhone()
                        }
                    }
                })
            },

            rejectWire() {
                this.cancel()
            },

            wirePhone() {
                this.$router.push({
                    name: 'wv-wirephone',
                    params: {
                        onlyPhone: false
                    }
                })
            },

            showCardsCountWarning() {
                this.$eventBus.$emit('modal:dialog', {
                    props: {
                        message: 'Достигнут лимит кол-во привязанных адресов к одной учетной записи. Чтобы добавить новый адрес необходимо отвязать один из уже имеющихся.',
                        acceptText: 'Выход'
                    },
                    dialogProps: {
                        noClickAnimation: true,
                        persistent: true,
                    },
                    listeners: {
                        accept: () => {
                            this.rejectWire()
                        }
                    }
                })
            }
        },
        created() {
            if (!this.newUser) {

                let userInfo = this.$store.state.settings.userInfo

                if (userInfo && userInfo.cards && userInfo.cards.length >= 5) {
                    this.showCardsCountWarning()
                } else if (!userInfo || !userInfo.contacts.phone) {
                    this.askWire()
                }
            }
        }
    }
</script>

<style>

</style>